import { render, staticRenderFns } from "./DnaProd.vue?vue&type=template&id=6eefe270&"
import script from "./DnaProd.vue?vue&type=script&lang=js&"
export * from "./DnaProd.vue?vue&type=script&lang=js&"
import style0 from "./DnaProd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports